import {ISelectItem} from '../drop-down';
import {ICenter} from './center';

export interface IDateRangeSchema {
    endDate: Date;
    startDate: Date;
}

export interface ICount {
    count: number;
    _id: string;
    totalParticipants?: number;
}

export interface IDynamicReportSchema {
    endDate?: string;
    startDate?: string;
    reportType?: ISelectItem[];
    centers?: ICenter[];
    activityType?: ISelectItem;
    activitySubType?: ISelectItem;
}

export type CrActivitySummaryResponse = Record<string, CrActivitySumary[]>;
export type CrActivitySumary = {title: string; total: number; [key: string]: string | number};
export type TableReportData = {count: number; title: string};
export type PopulatedReportData = {TYPE: string; CRG: number};
export type ParticipantsCount = {count: number};
export type ActivityTypeCount = {title: string; type: string; counts: Record<string, number>};

export const MOPC_USER_COUNT = {label: 'User Counts', _id: 'user_count'};
export const MOPC_DEMOGRAHPHICS = {label: 'Demographics', _id: 'demographics'};
export const MOPC_DEMOGRAHPHICS_LOC = {label: 'Demographics Locations', _id: 'demographics_locations'};
export const MOPC_USER_DETAILS = {label: 'User Details', _id: 'user_details'};
export const MOPC_CR_ACTIVITY_SUMMARY = {label: 'CR Activity Summary Overview', _id: 'cr_activity_summary_overview'};
export const MOPC_CR_MEDIATION_ACTIVITY_OVERVIEW = {
    label: 'CR Mediation Closed Activity Overview',
    _id: 'cr_mediation_closed_activity_overview',
};
export const MOPC_ENTITY_TYPE = {label: 'Entity Type Count', _id: 'entity_type_count'};
export const MOPC_ENTITY_NAMES = {label: 'Entity Name Count', _id: 'entity_name_count'};
export const MOPC_DISPOSITION_BY_DISPUTE_TYPE = {
    label: 'Dispositions by Dispute Type',
    _id: 'dispositions_by_dispute_type',
};
export const MOPC_DISPOSITION_BY_ENTITY_TYPE = {label: 'Disposition by Entity Type', _id: 'disposition_by_entity_type'};
export const MOPC_OUTREACH = {label: 'Outreach', _id: 'outreach'};
export const MOPC_LOCATION_NAME_COUNT = {label: 'Location Name Count', _id: 'lnc'};
export const MOPC_SERVICE_LOCATION_COUNT = {label: 'Serivce Location Count', _id: 'slc'};
export const MOPC_ACTIVITY_MEDIUM_OVERVIEW = {label: 'Activity Medium Overview', _id: 'amo'};
export const MOPC_ACTIVITY_COUNTS = {label: 'Activity Counts', _id: 'ac'};

export const MOPC_REPORTS_TYPES: ISelectItem[] = [
    MOPC_ACTIVITY_COUNTS,
    // MOPC_ACTIVITY_MEDIUM_OVERVIEW,
    MOPC_CR_ACTIVITY_SUMMARY,
    MOPC_CR_MEDIATION_ACTIVITY_OVERVIEW,
    // MOPC_DEMOGRAHPHICS,
    // MOPC_DEMOGRAHPHICS_LOC,
    // MOPC_DISPOSITION_BY_DISPUTE_TYPE,
    // MOPC_DISPOSITION_BY_ENTITY_TYPE,
    MOPC_ENTITY_NAMES,
    // MOPC_ENTITY_TYPE,
    // MOPC_LOCATION_NAME_COUNT,
    MOPC_OUTREACH,
    // MOPC_SERVICE_LOCATION_COUNT,
    // MOPC_USER_COUNT,
    // MOPC_USER_DETAILS,
];

export interface IDispositionDisputeType {
    isMain: boolean;
    mainDispute: string;
    subType: string;
    title: string;
    [key: string]: string | boolean | number;
}

export interface DataItem {
    _id: string | null;
    count: number;
    mean?: number | null;
    median?: number | null;
    centerAcronym?: {_id: string | null; count: number}[];
}
